import { ScaffoldSelection } from "../../interface";
import { isRowInSelection } from "./isRowInSelection";

/**
 * Toggles a row in the selectedRows list, adding it if absent or removing it if present.
 * Preserves all cell and column selections.
 *
 * @param selection - The current scaffold selection state.
 * @param rowId - The row ID to toggle.
 * @returns A new selection state with the row toggled.
 */
export const toggleRowInSelection = (
  selection: ScaffoldSelection,
  rowId: string,
): ScaffoldSelection => {
  if (isRowInSelection(selection, rowId)) {
    return {
      ...selection,
      selectedRows: selection.selectedRows.filter((r) => r.firstCellId !== rowId),
    };
  }

  return {
    ...selection,
    selectedRows: [...selection.selectedRows, { firstCellId: rowId }],
  };
};
